import React, { useState } from "react";
import reactCSS from "reactcss";
import { SketchPicker } from "react-color";

function ColorPicker({ color, onChange }) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  const handleChange = (newColor) => {
    if (typeof onChange === "function") {
      onChange(newColor.rgb);
    }
  };

  const styles = reactCSS({
    default: {
      picker: {
        width: "180px",
      },
      color: {
        width: "50px",
        height: "20px",
        borderRadius: "2px",
        background: color
          ? `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`
          : "#ffffff",
      },
      swatch: {
        padding: "5px",
        background: "#fff",
        borderRadius: "1px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
        display: "inline-block",
        cursor: "pointer",
      },
      popover: {
        position: "fixed",
        zIndex: 2,
      },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
      },
    },
  });

  return (
    <div>
      <div style={styles.swatch} onClick={handleClick}>
        <div style={styles.color} />
      </div>
      {displayColorPicker ? (
        <div style={styles.popover}>
          <div style={styles.cover} onClick={handleClose} />
          <SketchPicker
            size={6}
            customPickerStyles={styles.picker}
            onChange={handleChange}
            color={color}
            presetColors={[
              "#FF1493",
              "#FBFBFB",
              "#FF0000",
              "#008000",
              "#0000FF",
              "#FFA500",
              "#3f51b5",
            ]}
          />
        </div>
      ) : null}
    </div>
  );
}

export default ColorPicker;
